import { ApiCatch } from "@/utils/decorators";
import { PointRequest } from "~/PointRequest.type";
import { Api } from "../api.service";

export class AccountingPointsService {
  @ApiCatch
  static async getPointList(pointRequest: PointRequest) {
    const response = await Api.get("/points/", {
      params: pointRequest,
    });
    return response.data;
  }
}
